import { apiPost } from 'utils/API/actions/request'
import { HISTORY_NEGOTIATION } from '../constants'

export const getHistoryNegotiation = (body) => apiPost({
  entity: HISTORY_NEGOTIATION,
  url: '/financial/getfinancialagreementhistory',
  data: body,
  isChainable: true
})
